/* script */
//
//
//
//
//
//
//
//
//
import { getKey, isPxOrPercentage } from './utils';
import SubMixin from './mixins/sub';
var __vue_script__ = {
  name: 'ColGroup',
  mixins: [SubMixin],
  computed: {
    cols: function () {
      var fixed = this.fixed,
          flatColumns = this.flatColumns,
          leftFlatColumns = this.leftFlatColumns,
          rightFlatColumns = this.rightFlatColumns;
      var cols = flatColumns;

      if (fixed === 'left') {
        cols = leftFlatColumns;
      } else if (fixed === 'right') {
        cols = rightFlatColumns;
      }

      return cols;
    },
    expandCellCols: function expandCellCols() {
      var prefixCls = this.prefixCls,
          expandIconAsCell = this.expandIconAsCell,
          fixed = this.fixed,
          cols = this.cols;
      var nCols = cols;

      if (fixed !== 'right' && expandIconAsCell) {
        nCols.unshift({
          className: "".concat(prefixCls, "-expand-icon-col")
        });
      }

      return nCols;
    }
  },
  methods: {
    getKey: getKey,
    colStyle: function colStyle(col) {
      var width = col.width;
      var style = null;

      if ('width' in col) {
        var w = isPxOrPercentage(width) ? width : "".concat(width, "px");
        style = {
          width: w,
          minWidth: w
        };
      }

      return style;
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('colgroup', _vm._l(_vm.expandCellCols, function (col, i) {
    return _c('col', {
      key: _vm.getKey(col, i),
      style: _vm.colStyle(col)
    });
  }), 0);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "colGroup.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);